import { render, staticRenderFns } from "./TablaPrioridadClinica.vue?vue&type=template&id=e7962086&scoped=true"
import script from "./TablaPrioridadClinica.vue?vue&type=script&lang=js"
export * from "./TablaPrioridadClinica.vue?vue&type=script&lang=js"
import style0 from "./TablaPrioridadClinica.vue?vue&type=style&index=0&id=e7962086&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7962086",
  null
  
)

export default component.exports